import { ToastProps } from '../../types/Toast.types';
import EventManager from './EventManager';

export const toastEventManager = new EventManager();

export const showToast = ({ type, text, duration }: ToastProps) => {
  toastEventManager.emit('addToast', { type, text, duration });
};
